import { ProgramEngagement } from '@cibo/core'
import { useCreateProgramEngagement } from '@cibo/programs'
import { LoadingButton } from '@mui/lab'
import { ButtonProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

type CreateProgramEngagementButtonProps = {
  onSuccess: (engagement: ProgramEngagement) => void
  programId: ProgramEngagement['programId']
  userId: ProgramEngagement['ownedBy']['userId']
} & Omit<ButtonProps, 'onClick'>

export const CreateProgramEngagementButton = ({
  onSuccess,
  programId,
  userId,
  ...buttonProps
}: CreateProgramEngagementButtonProps) => {
  const createEngagement = useCreateProgramEngagement()
  const { t } = useTranslation('@cibo/impact/CreateProgramEngagementButton')

  const onClick = () => {
    createEngagement
      .mutateAsync({ programId, userId, doesUpsert: false })
      .then(({ data }) => onSuccess(data))
  }

  return (
    <LoadingButton
      loading={createEngagement.isLoading}
      onClick={onClick}
      variant="contained"
      {...buttonProps}
    >
      {t('create')}
    </LoadingButton>
  )
}
